import { debounce } from 'lodash';
import app from '../angular_app.es6';

app.factory('OrientationService', [ '$rootScope', '$timeout', ($rootScope, $timeout) => {
  let launched = false;
  const breakPoint = 1280, debounceTimeout = 100;

  const defineOrientation = () => {
    return $(window).width() < breakPoint ? 'vertical' : 'horizontal';
  };

  const customOrientations = [
    { name: 'vertical', label: 'Vertical wordcloud', width: 400, height: 800 },
    { name: 'horizontal', label: 'Horizontal wordcloud', width: 800, height: 400 }
  ];

  const runBody = () => {
    $timeout(() => {
      $rootScope.$broadcast('orientationChange', defineOrientation());
    });
  };

  const run = () => {
    if (launched) {
      return;
    }
    window.onresize = debounce(runBody, debounceTimeout);
    launched = true;
  };

  return {
    run,
    define: defineOrientation,
    customList: customOrientations
  };
} ]);
